<template>
    <div class="h-full w-full fixed top-0 left-0 bg-black/50 overflow-auto z-1000 modal--contant_main"
         :class="modalClass"
         @click.self="$emit('close')"
    >
        <div class="my-10 mx-auto bg-white overflow-auto modal--content_child"
            :class="{
                'w-1/5' : size === '-sm',
                'w-2/5' : size === '-md',
                'w-3/5' : size === '-lg',
                'w-4/5' : size === '-xl',
                'w-auto': widthIsAuto,
                [wrapperClass]: true }"
        >
            <div class="flex-1">
                <div class="px-4  ">
                    <div class="flex items-start border--title justify-between space-x-3">
                        <div class="space-y-1">
                            <slot name="header"></slot>
                        </div>
                        <div class="h-7 flex items-center">
                            <button class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-custom-green" title="Close this window" @click.prevent="$emit('close')">
                                <svg-vue icon="times" class="h-6 w-6 fill-gray-500 hover:fill-black" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="mb-4 text--content" :class="bodyClass">
                    <slot name="body"></slot>
                </div>
            </div>

            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            size: String,
            modalClass: String,
            wrapperClass: String,
            bodyClass: String,
            footerClass: String,
            widthIsAuto: Boolean
        },
        mounted() {
            document.querySelector('html').classList.add("-withmodal");
        },
        unmounted() {
            document.querySelector('html').classList.remove("-withmodal");
        }
    }
</script>
